import Cookies from 'js-cookie';

import { orgTypes } from './modules/orgTypes/store';
import { fileUploader } from './modules/fileUploader/store';
import { regions } from './modules/regions/store';
import { modal } from './modules/modal/store';
import { notification } from './modules/notification/store';
import { auth } from './modules/sign/store';

import { profile } from './modules/home/profile/store';
import { profileTariff } from './modules/home/profileTariff/store';
import { balance } from './modules/home/balance/store';
import { requests } from './modules/home/requests/store';
import { monitoring } from './modules/home/monitoring/store';
import { monitoringSubject } from './modules/modal/ModalMonitoringEvent/store';
import { contractStatus } from './modules/home/contractStatus/store';
import { edoTypes } from './modules/home/contractElectronic/store';
import { contract } from './modules/home/contract/store';
import { tariff } from './modules/home/tariff/store';
import { tariffHistory } from './modules/home/tariffHistory/store';
import { tariffCalculate } from './modules/home/tariffCalculate/store';
import { costs } from './modules/home/costs/store';
import { paymentHistory } from './modules/home/paymentHistory/store';
import { request } from './modules/home/request/store';
import { requestTableInns } from './modules/home/requestTableInns/store';
import { training } from './modules/home/training/store';
import { reportExample } from './modules/home/reportExample/store';

export function createStore(state = {
    authorized: false,
}) {
    return {
        state,
        mutations: {
            authorize(state, authorized) {
                state.authorized = authorized;
            },
        },
        actions: {
            authorize({ commit }) {
                commit('authorize', true);
            },
            deauthorize({ commit, dispatch }) {
                commit('authorize', false);
                dispatch('balance/resetState');
                dispatch('profile/resetState');
                dispatch('auth/resetState');
                dispatch('profileTariff/resetState');
            },
            error({ dispatch }, response) {
                switch (true) {
                    // Unauthorized
                    case response.status === 401:
                        dispatch('deauthorize');
                        Cookies.remove('token');
                        window.location.reload();
                        break;
                    case response.status === 404:
                    case response.status >= 500:
                        dispatch('notificationShow', response.message);
                        break;
                }

                // throw response;
            },
            notificationShow({ dispatch }, message) {
                dispatch('notification/show', message);
            }
        },
        modules: {
            fileUploader,
            edoTypes,
            notification,
            modal,
            auth,
            orgTypes,
            regions,
            profile,
            profileTariff,
            balance,
            requests,
            monitoring,
            monitoringSubject,
            contractStatus,
            contract,
            tariff,
            tariffHistory,
            tariffCalculate,
            costs,
            paymentHistory,
            request,
            requestTableInns,
            training,
            reportExample,
        }
    }
}



// WEBPACK FOOTER //
// ./src/store.js